module.exports = __webpack_public_path__ + "static/NewJune-extrabold-ef281936a0e6b675bcc7f30be1908ac6.woff";